// src/library/container.tsx
import { Card, Divider, Flex, Heading, View } from "@aws-amplify/ui-react";
import type { ReactNode } from "react";

interface ContainerProps {
  heading: string;
  actionBox?: ReactNode;   // ⬅ FIXED: was JSX.Element
  minHeight?: number;
  children?: ReactNode;
  padBody?: number;
}

export function Container(props: ContainerProps) {
  return (
    <Card
      variation="elevated"
      padding="0px"
      marginBlock={10}
      minHeight={props.minHeight}
      // prevent scrollbars from being clipped by Card
      style={{ overflow: "visible" }}
    >
      <Flex direction="row" padding={10}>
        <Heading>{props.heading}</Heading>
        {props.actionBox}
      </Flex>
      <Divider />
      <View padding={props.padBody ?? 10}>{props.children}</View>
    </Card>
  );
}
